import { ServiceItem } from '@/models/quote-template';
import { QuoteServiceItemService } from '@/services/quote-item-service';
import { ActionTree, GetterTree, MutationTree } from 'vuex';

const quoteService = new QuoteServiceItemService();

export const state = {
  quoteItems: [] as ServiceItem[]
};

type QuotesState = typeof state;

export const mutations: MutationTree<QuotesState> = {
  SET_QUOTE_ITEMS(state, payload: ServiceItem[]) {
    state.quoteItems = payload;
  },

  ADD_QUOTE_ITEM(state, payload: ServiceItem) {
    state.quoteItems.push(payload);
  },

  UPDATE_QUOTE_ITEM(state, payload: ServiceItem) {
    const index = state.quoteItems.findIndex(
      (quote: ServiceItem) => quote.id === payload.id
    );
    state.quoteItems.splice(index, 1, payload);
  },

  REMOVE_QUOTE_ITEM(state, payload: number) {
    const index = state.quoteItems.findIndex(
      (quote: ServiceItem) => quote.id === payload
    );
    state.quoteItems.splice(index, 1);
  }
};

export const actions: ActionTree<QuotesState, QuotesState> = {
  createQuoteService: async ({ commit }, payload: ServiceItem) =>
    quoteService
      .createQuoteService(payload)
      .then((quote: ServiceItem) => commit('ADD_QUOTE_ITEM', quote)),

  fetchQuoteServices: async ({ commit }, language?: string) =>
    quoteService
      .fetchQuoteServices(language)
      .then((quoteItems: ServiceItem[]) => {
        commit('SET_QUOTE_ITEMS', quoteItems);
      }),

  fetchQuoteService: async ({ commit }, payload: number) =>
    quoteService.fetchQuoteService(payload).then((quote: ServiceItem) => {
      const index = state.quoteItems.findIndex(
        (v: ServiceItem) => v.id === quote.id
      );
      if (index === -1) {
        commit('ADD_QUOTE_ITEM', quote);
      } else {
        commit('UPDATE_QUOTE_ITEM', quote);
      }
      return quote;
    }),

  updateQuoteService: async ({ state, commit }, payload: ServiceItem) =>
    quoteService.updateQuoteService(payload).then((quote: ServiceItem) => {
      const index = state.quoteItems.findIndex(
        (v: ServiceItem) => v.id === quote.id
      );
      if (index === -1) {
        commit('ADD_QUOTE_ITEM', quote);
      } else {
        commit('UPDATE_QUOTE_ITEM', quote);
      }
    }),

  deleteQuoteService: async ({ commit }, payload: number) =>
    quoteService.deleteQuoteService(payload).then(() => {
      commit('REMOVE_QUOTE_ITEM', payload);
    })
};

export const getters: GetterTree<QuotesState, QuotesState> = {
  getQuoteServiceById: state => (id: number) =>
    state.quoteItems.find(quote => quote.id === id)
};
